import { createAction } from 'redux-actions';

export type DonatePointsPayload = {
  moduleId: number;
  amount: number;
  message?: string;
  isPrivate?: boolean;
};

export const donatePoints = createAction(
  'DONATIONS.DONATE_POINTS',
  (payload: DonatePointsPayload) => payload
);
